import type { ProductCollectionSitemap } from '../../types';
import type { MetaDataContext } from './types';

type Props = {
  data: {
    productCollectionSitemap: ProductCollectionSitemap;
  };
};

export default (props: Props, { t }: MetaDataContext) => {
  const { data } = props;
  if (!data?.productCollectionSitemap) {
    return {};
  }

  const title = t('meta', 'product-collection-sitemap.title', {
    title: data.productCollectionSitemap.name || '',
  });
  const description = t('meta', 'product-collection-sitemap.description', {
    title: data.productCollectionSitemap.name || '',
  });

  return {
    noIndex: true,
    follow: true,
    title,
    description,
    openGraph: [
      {
        key: 'title',
        content: title,
      },
      {
        key: 'desc',
        content: description,
      },
      {
        key: 'type',
        content: 'website',
      },
    ],
  };
};
